<template>
  <div id="pageRoot" class="blind">
    <span class="normalTheme pageInstruction" style="left: 30px; top: 40px">
      <p>Escucha con atención este texto.</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 30px; top: 90px">
      <p>Tacha las palabras que esten repetidas.</p>
    </span>

    <img
  style="width: 200px; top: 260px; right: 30px"
  class="pageElement"
  src="/pages/img/blindcas/assets_p42/castillo.svg"
  />

    <p class="textBase appearAnimationB" id="crossingText" style="z-index: 6" ref="crossingText">
      "Los castillos estaban rodeados por una alta muralla. Los castillos también estaban rodeados por un gran foso con o sin agua. para cruzar el foso del castillo fue necesario construir puentes. Algunos puentes eran de piedra y otros eran levadizos."
    </p>

    <p class="normal" style="left: 30px; top: 560px;">
        Entre todos escriban el texto en el pizarrón, dictándole al maestro.
	</p>

  </div>
</template>
<style scoped>
#crossingText {
  position: absolute;
  width: 790px;
  height: 214px;
  left: 30px;
  top: 220px;
  font-size: 35px;
  line-height: 45px;
  text-transform: uppercase;
  color: #2bb673;
  cursor: default;
}
</style>
<script>
	export default {
		data() {
			return {
				videos: [
					"glo/Video 154_155 b.mp4",
					"glo/Video 156b.mp4",
					"glo/Video 157b.mp4",
					"glo/Video 158.mp4",
				]
			};
		},
		methods:{
		dbId(name, option){
			return `${this.$parent.type}-${this.$parent.page}-${name}-${option}`
		},
		async loadOption(name, option) {
			var id = this.dbId(name, option);

			var value = await this.$db.options.get({
			id: id,
			}).catch(function(error){
			console.log("error getting option" + error);
			});
			if (value === undefined) return;
			console.log(value);

			if (value.option){
				this.crossWord(option);
			}

			console.log("option loaded: " + id + ", " + value.option);
		},
		saveOption(name, option) {
			var id = this.dbId(name, option);

			var word = document.getElementById(option);
			var c = " highlight"

			var value = word.className.includes(c);

			this.$db.options.put({
				id: id,
				option: value
			}).catch(function(error){
				console.log("error saving option" + error);
			});

			console.log("option saved: " + id + ", " + value);
		},
		setupCrossText(t){
				var words = t.innerHTML.split( " " );
				this.$refs["crossingText"].innerHTML="";
				for (var i = 0; i < words.length; i++) {
				this.$refs["crossingText"].innerHTML += '<span class="crossable" id="crt' + i + '">' + words[i] + "</span>" + " ";
				console.log(words[i]);
				}
				document.querySelectorAll('.crossable').forEach(item => {
					item.addEventListener('click', () => {
					this.crossWord(item.id);
					this.saveOption('crossingText', item.id);
					})
				})
			},
		crossWord(id){
				var word = document.getElementById(id);
				var c = " highlight"
				if (word.className.includes(c)) {
					word.className = word.className.replace(c, "")
				}
				else
				{
					word.className += c;
				}
			}
		},
		mounted(){
			this.setupCrossText(this.$refs["crossingText"]);
			document.querySelectorAll('.crossable').forEach(item => {
				this.loadOption('crossingText', item.id);
			})
		}
	}
</script>